module.exports = __webpack_public_path__ + "static/media/plus.83485d18.svg";